module.exports = __webpack_public_path__ + "img/4-1.b5eec657.png";